const SHOPPING_CONTEXT_API = '/sitecore/api/ssc/rw/isagenix/shoppingcontextapi/SetShoppingContextUrl';

export async function redirectToGateway(request) {
    let url = `${SHOPPING_CONTEXT_API}`;
    return $.ajax({
        type: 'POST',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}
